module.exports = __webpack_public_path__ + "static/uti-neonatal-f516d0bf91ebbfccb1c4a393fa7e9bfd.jpg";